export default {"src":"/_next/static/media/accuracy-icon.5c3f6ccf.svg","height":93,"width":103,"blurWidth":0,"blurHeight":0};